import { useEffect } from 'react';

/**
 * Meta Pixel — Softball Season-Ready (DPS-33).
 * Única fuente del pixel: se inicializa solo acá y dispara un único
 * PageView por carga de página, solo para este pixel.
 */
const PIXEL_ID = '1110847538259042';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __dps33PixelPageViewSent?: boolean;
  }
}
function loadFbq(): Fbq {
  if (window.fbq) return window.fbq;
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
  } as Fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  return fbq;
}
export function MetaPixel() {
  useEffect(() => {
    // Guard global: sobrevive a re-montajes y al doble efecto de StrictMode.
    if (window.__dps33PixelPageViewSent) return;
    window.__dps33PixelPageViewSent = true;
    const fbq = loadFbq();
    fbq('init', PIXEL_ID);
    // trackSingle: el PageView va solo a este pixel aunque haya otro cargado.
    fbq('trackSingle', PIXEL_ID, 'PageView');
  }, []);
  return null;
}